import React from "react";

import { UserAcknowledgementModal } from "@/ui/organisms/UserAcknowledgement";

export type ViewUserConsentModalParams = {
    useState: () => {
        showModal: boolean;
        userConsentChecked: boolean;
    };
    useCases: () => {
        onConfirm: () => Promise<void>;
        setUserConsentChecked: (consent: boolean) => void;
    };
};

export type ViewUserConsentModalProps = Record<string, never>;

export const testIds = {
    main: "ViewUserConsentModal",
    checkbox: "ViewUserConsentModal-checkbox",
    buttonConfirm: "ViewUserConsentModal-button-confirm",
};

export const createViewUserConsentModal = ({
    useState,
    useCases,
}: ViewUserConsentModalParams) => {
    const ViewUserConsentModal: React.FC<ViewUserConsentModalProps> = () => {
        const { showModal, userConsentChecked } = useState();
        const { onConfirm, setUserConsentChecked } = useCases();
        const handleConfirm = () => {
            void onConfirm();
        };

        return (
            <UserAcknowledgementModal
                showModal={showModal}
                userConsentChecked={userConsentChecked}
                setUserConsentChecked={setUserConsentChecked}
                onConfirm={handleConfirm}
            />
        );
    };

    return ViewUserConsentModal;
};
